import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/apiClient.ts'

interface UseGetAttributeArgs {
  attributeId: string
}

export const getAttributeQueryOptions = (args: UseGetAttributeArgs) =>
  queryOptions({
    queryKey: ['attributes', args.attributeId],
    queryFn: async () => {
      const result = await apiClient.attributes[':attributeId'].$get({
        param: args,
      })

      return result.json()
    },
  })

export const useGetAttribute = (
  args: UseGetAttributeArgs,
  options?: Partial<ReturnType<typeof getAttributeQueryOptions>>
) =>
  useQuery({
    ...getAttributeQueryOptions(args),
    ...options,
  })
